export default function MissionVision() {
  return (
    <section className="py-16 md:py-24 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
            <div className="glass-card p-6 md:p-8 group">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-accent/10 group-hover:bg-emerald-accent/20 transition-colors duration-300 mb-5">
                <i className="ri-crosshair-line text-xl text-emerald-accent"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4 group-hover:text-emerald-soft transition-colors duration-300">Our Mission</h2>
              <p className="text-base md:text-lg text-silver-300 leading-relaxed">
                To help businesses operate with clarity, control, and efficiency through structured, technology-driven systems.
              </p>
            </div>
            <div className="glass-card p-6 md:p-8 group">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-accent/10 group-hover:bg-emerald-accent/20 transition-colors duration-300 mb-5">
                <i className="ri-eye-line text-xl text-emerald-accent"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-white mb-4 group-hover:text-emerald-soft transition-colors duration-300">Our Vision</h2>
              <p className="text-base md:text-lg text-silver-300 leading-relaxed">
                To become the leading provider of business operating systems for African enterprises.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
